import { createSetQuotesDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useQuotesData = (params, dataFresh) => {
  return useGetAndSet("quotes", params, createSetQuotesDataAction, dataFresh);
};
